module.exports = function() {
  return new Worker("/" + "monaco-typings-ata.1ade573d.worker.js");
};